export default __webpack_public_path__ + "deafde133ad00e5c3c376226b54396a4.png";